"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPictureOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M4 4v24h24V4zm22 2v15h-1a1.88 1.88 0 01-2-2v-1h-1a9.6 9.6 0 00-5.62 2.21 2.47 2.47 0 01-2.15.74c-3-.7-2.25-6.75-2.24-6.81l.16-1.14H11a11.31 11.31 0 00-5 1.31V6zM6 26v-9.2a7.12 7.12 0 013.9-1.7c-.1 2.27.16 6.94 3.87 7.8a4 4 0 00.88.1 4.87 4.87 0 003-1.21 8.57 8.57 0 013.53-1.68A3.79 3.79 0 0025 23h1v3z" }),
        React.createElement("path", { d: "M19.5 16a3.5 3.5 0 10-3.5-3.5 3.5 3.5 0 003.5 3.5zm0-5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5z" })));
}
exports.default = SvgPictureOutline;
//# sourceMappingURL=PictureOutline.js.map